import axios from 'axios';
import TokenService from './token.service';

const baseURL = process.env.REACT_APP_API_URL;

const API = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'Accept-Language': localStorage.getItem('i18nextLng'),
  },
});

API.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    } else {
      config.headers['Authorization'] = null;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(
  (response) => response,
  async function (error) {
    const originalConfig = error?.response?.config;
    const currentPath = window.location.pathname;
    const isPublicAuthPage =
      currentPath === '/' || currentPath === '/login' || currentPath === '/register' || currentPath === '/ib-schools';

    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error?.toJSON?.().message === 'Network Error') {
      // alert('No internet connection');
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      try {
        const rs = await axios.post(baseURL + '/auth/refresh/', {
          refresh: TokenService.getLocalRefreshToken(),
        });
        const token = rs.data.access;
        TokenService.updateLocalAccessToken(token);
        return API(originalConfig);
      } catch (refreshError) {
        TokenService.removeTokens();
        if (!isPublicAuthPage) {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default API;
